import React, { useState } from "react";
import "./styles.css";

function MailForm() {
  const [header, setHeader] = useState("");
  const [text, setText] = useState("");
  // const [receivers, setReceivers] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [buttonText, setButtonText] = useState("Sign up");
  const [buttonURL, setButtonURL] = useState("https://webet360.com/casino");

  // Обработчик изменения изображения
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    setImageFile(selectedFile);

    // Генерируем превью для изображения
    if (selectedFile && selectedFile.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPreviewUrl(ev.target.result);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setPreviewUrl(null);
    }
  };

  // Обработчик изменения CSV файла
  const handleExcelChange = (e) => {
    const selectedFile = e.target.files[0];
    setExcelFile(selectedFile);
    // Не требуется превью для CSV-файла
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    // Поле From фиксировано на сервере, поэтому его можно не отправлять
    formData.append("header", header);
    formData.append("text", text);
    // formData.append("receivers", receivers);
    formData.append("buttonText", buttonText);
    formData.append("buttonURL", buttonURL);
    if (imageFile) {
      formData.append("image", imageFile);
    }
    if (excelFile) {
      formData.append("excel", excelFile);
    }

    try {
      const response = await fetch("/send", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        const msg = await response.text();
        alert("Ошибка при отправке: " + msg);
      } else {
        alert("Письмо отправлено!");
      }
    } catch (err) {
      console.error("Ошибка при запросе:", err);
      alert("Ошибка при запросе: " + err.message);
    }
  };

  return (
    <div className="container">
      <h1>Mailing</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>From:</label>
          <input
            type="text"
            name="from"
            value="WeBet360 <info@webet360.casino>"
            disabled
          />
        </div>

        <div>
          <label>Header (Subject):</label>
          <input
            type="text"
            name="header"
            placeholder="Theme mail"
            value={header}
            onChange={(e) => setHeader(e.target.value)}
          />
        </div>

        <div>
          <label>Text:</label>
          <br />
          <textarea
            name="text"
            rows={5}
            cols={40}
            placeholder="Text mail..."
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        <div>
          <label>Image (attachment):</label>
          <label className="file-input-label">
            +
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </label>
          {previewUrl && (
            <div id="imagePreview">
              <img
                src={previewUrl}
                alt="preview"
                style={{ maxWidth: "100px", maxHeight: "100px", marginTop: "10px" }}
              />
            </div>
          )}
        </div>

        <div>
          <label>Excel (CSV):</label>
          <input
            type="file"
            name="excel"
            accept=".csv"
            onChange={handleExcelChange}
          />
        </div>

        <div>
          <label>Button Text:</label>
          <input
            type="text"
            name="buttonText"
            placeholder="Sign up"
            value={buttonText}
            onChange={(e) => setButtonText(e.target.value)}
          />
        </div>

        <div>
          <label>Button URL:</label>
          <input
            type="text"
            name="buttonURL"
            placeholder="https://webet360.com/casino"
            value={buttonURL}
            onChange={(e) => setButtonURL(e.target.value)}
          />
        </div>

        {/* <div>
          <label>Receivers (through space or ,):</label>
          <input
            type="text"
            name="receivers"
            placeholder="email1@example.com, email2@example.com"
            value={receivers}
            onChange={(e) => setReceivers(e.target.value)}
          />
        </div> */}

        <button type="submit">Send Mail</button>
      </form>
    </div>
  );
}

export default MailForm;
